import { render, staticRenderFns } from "./carrier.vue?vue&type=template&id=158e6df8&scoped=true&"
import script from "./carrier.vue?vue&type=script&lang=js&"
export * from "./carrier.vue?vue&type=script&lang=js&"
import style0 from "./carrier.vue?vue&type=style&index=0&id=158e6df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e6df8",
  null
  
)

export default component.exports